/**
 * 域名检查工具类
 */

/**
 * 检查当前域名是否为 alleatapp.com
 * @returns {boolean} 是否为 alleatapp.com 域名
 */
export function isAlleatDomain() {
  const hostname = window.location.hostname;
  return hostname.includes('alleatapp.com');
}

/**
 * 检查是否需要使用 webview 登录
 * @returns {boolean} 是否需要使用 webview
 */
export function shouldUseWebviewLogin() {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isAlleat = hostname.includes('alleatapp.com');
  
  // 只有在非alleat域名且非localhost时才使用webview
  return !isAlleat && !isLocalhost;
}

/**
 * 获取当前域名信息
 * @returns {Object} 域名信息
 */
export function getDomainInfo() {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isAlleat = hostname.includes('alleatapp.com');
  
  return {
    hostname,
    isLocalhost,
    isAlleat,
    shouldUseWebview: !isAlleat && !isLocalhost
  };
}
